import {Dialog, SxProps} from '@mui/material';
import {FC, Fragment, Suspense, useMemo} from 'react';
import {Outlet} from 'react-router-dom';
import {BalancePayment} from '../../modules/balance-and-payment';
import {ClientTariffs} from '../../modules/client-tariffs';
import {Profile} from '../../modules/profile';
import {Spinner} from '../../modules/profile/components/spinner';
import {ModalKey, useModalPageStore} from '../../store/modalPage';
import {MODAL_LAYER_Z_INDEX} from '../../ui/modal-layers';
import {CompanyTariffRestrictionDialog} from '../../modules/company-tariff';

const STYLE = {
  DIALOG: {
    zIndex: MODAL_LAYER_Z_INDEX.cabinet,
    '& > .MuiDialog-container > .MuiPaper-root': {
      background: 'none',
      boxShadow: 'none',
      width: 'unset',
      maxWidth: 'unset',
      p: 0,
      m: 0,
    },
  },
} as const satisfies SxProps;

export const ModalPageProvider: FC = () => {
  const {modalKey, hideModalContent} = useModalPageStore();
  const modalRegistry = useMemo<Record<ModalKey, JSX.Element>>(
    () => ({
      profile: <Profile />,
      balancePayment: <BalancePayment />,
      clientTariffs: <ClientTariffs />,
    }),
    [],
  );
  const modalContent = modalKey ? modalRegistry[modalKey] : null;

  return (
    <Fragment>
      <CompanyTariffRestrictionDialog />
      <Dialog
        onClose={hideModalContent}
        open={!!modalContent}
        sx={STYLE.DIALOG}
        fullWidth
        scroll="body"
        disableScrollLock
      >
        <Suspense fallback={<Spinner />}>{modalContent}</Suspense>
      </Dialog>
      <Outlet />
    </Fragment>
  );
};
